module.exports = __webpack_public_path__ + "img/podcast.96a2b2eb.svg";